import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsultaGarantiaComponent } from './modules/garantias/consulta-garantia/consulta-garantia.component'

const routes: Routes = [
  {component: ConsultaGarantiaComponent, path: 'garantia'},
  {component: ConsultaGarantiaComponent, path: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
